import axios from "axios";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../../config/config";
import React, { useEffect, useState,useMemo } from "react";
import DataTable from "react-data-table-component";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from '@mui/material';
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { toastSuccess } from "../../../../common/Toast";
import { DELETE_MESSAGE } from "../../../../common/Constant";

const CountInventory = (props) => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const [status, setStatus] = useState("open");
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(10);
  const locationId = localStorage.getItem("Location");

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const handlePerRowsChange = async (page, newPerPage, pstatus) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, pstatus);
  };
  console.log("dataaa::>>", data);
  const handlePageChange = (page, pstatus) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, pstatus);
  };

  const handleListData = (pagenumber, pagesize, pstatus,filtercolumnsearchtext,currentorder,ordercolumn,filtertext) => {
    // console.log(pagenumber, pagesize, pstatus);
    setLoading(true);
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    axios
      .get(
        `${config.itemsBaseUrl}/items/countitemslist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${sorting[0]?.desc === undefined
          ? "desc"
          : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagenumber=${pagination.pageIndex + 1}&pagesize=${pagination.pageSize}&filtertext=${globalFilter == undefined ? "" : globalFilter}&status=${pstatus}&locationid=${locationId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);
        // console.log(
        //   "Total Records ==> ",
        //   res.data.ResponseData[0]?.TotalRecord
        // );
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        // console.log("err ==> ", err);
      });
  };

  const handleSubmit = () => {
    // Count Inventory Upsert
    navigate(`/new-inventory-count`);
    // setLoading(true);
    // axios
    //   .post(
    //     `${config.itemsBaseUrl}/items/countinventoryupsert`,
    //     {
    //       id: 0,
    //       loginuserid: Id,
    //       locationid: locationId,
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json;charset=UTF-8",
    //         "Access-Control-Allow-Origin": "*",
    //         Authorization: token,
    //       },
    //     }
    //   )
    //   .then((res) => {
    //     if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
    //       toastSuccess(SUCCESS_MESSAGE);
    //       // console.log(res.data.ResponseID);
    //       navigate(`/new-inventory-count/${res.data.ResponseID}`);
    //     } else if (
    //       res.data.ResponseCode === "ERROR" &&
    //       res.data.ResponseID === -1
    //     ) {
    //       toastError("Name" + ALREADY_EXIST);
    //     } else {
    //       toastError(ERROR_MESSAGE);
    //     }
    //     setLoading(false);
    //   })
    //   .catch((error) => {
    //     setLoading(false);
    //     // console.log("error: ", error);
    //   });
  };

  const handleStatus = (pStatus) => {
    // console.log("Status ==> ", pStatus);
    if (pStatus == "open") {
      setStatus("close");
    } else {
      setStatus("open");
    }
    handleListData(1, 10, pStatus);
  };

  const handleDeletePopup = (pID) => {
    // console.log("pID ==> ", pID);

    const deleteRequestParam = {
      id: pID,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true)
  };

  useEffect(() => {
    handleStatus(status);
  }, [ columnFilters,
    globalFilter,
    pagination,
    sorting,]);

  // Table Data
  // const columns = [
  //   // {
  //   //   name: "Id",
  //   //   selector: (row) => row.Id,
  //   //   width: "5%",
  //   //   sortable: true,
  //   // },
  //   {
  //     name: "Count Date",
  //     selector: (row) => moment(row.Countdate).format("DD MMMM YYYY"),
  //     // width: "10%",
  //     sortable: false,
  //   },
  //   {
  //     name: "Items Counted",
  //     selector: (row) => row.ItemsCounted,
  //     sortable: false,
  //     // width: "12%",
  //   },
  //   {
  //     name: "Employee",
  //     selector: (row) => row.Employee,
  //     sortable: false,
  //     width: "10%",
  //   },

  //   {
  //     name: "Status",
  //     // width: "10%",
  //     selector: "",
  //     sortable: false,
  //     cell: (row) => (
  //       <>
  //         <select className="form-control form-control-sm" value={row.Status == 3 ? 1 : 2}>
  //           <option value="" disabled>
  //             Select Status
  //           </option>
  //           <option value="1">Open</option>
  //           <option value="2">Close</option>
  //         </select>
  //       </>
  //     ),
  //   },
  //   // {
  //   //   name: "Comments",
  //   //   selector: "",
  //   //   sortable: false,
  //   //   cell: (row) => (
  //   //     <>
  //   //       <input className="form-control form-control-sm" defaultValue={row.Comment} />
  //   //     </>
  //   //   ),
  //   // },
  //   {
  //     name: "Delete Count",
  //     selector: "",
  //     cell: (row) => (
  //       row.Status != 1 && (
  //         <>
  //           <Link
  //             className="confirm-text btn btn-sm btn-danger btn-custom-padding"
  //             to="#"
  //             title="Delete"
  //             data-bs-toggle="modal"
  //             data-bs-target="#DeleteConfirmationModal"
  //             onClick={() => handleDeletePopup(row.Id)}
  //           >
  //             Delete Count
  //           </Link>
  //           {/* <button className="btn btn-danger">Delete Count</button> */}
  //         </>
  //       )
  //     ),
  //     sortable: false,
  //   },
  //   {
  //     name: "Count",
  //     selector: "",
  //     cell: (row) => (
  //       <>
  //         <Link
  //           className="btn btn-sm btn-success btn-custom-padding"
  //           to={`/new-inventory-count/${row.Id}`}
  //         >
  //           {status == "open" ? `View Count` : `Continue Count`}
  //         </Link>
  //       </>
  //     ),
  //     sortable: false,
  //   },
  // ];
  

  const columns = useMemo(() => [
    {
      header: "Delete Count",
      Cell: ({row}) => (
        row.original.Status != 1 && (
          <>
            <Link
              className="confirm-text btn btn-sm btn-danger btn-custom-padding"
              to="#"
              title="Delete"
              data-bs-toggle="modal"
              data-bs-target="#DeleteConfirmationModal"
              onClick={() => handleDeletePopup(row.original.Id)}
            >
              Delete Count
            </Link>
            {/* <button className="btn btn-danger">Delete Count</button> */}
          </>
        )
      ),
    },
    {
      header: "Count",
      Cell: ({row}) => (
        <>
          <Link
            className="btn btn-sm btn-success btn-custom-padding"
            to={`/new-inventory-count/${row.original.Id}`}
          >
            {status == "open" ? `View Count` : `Continue Count`}
          </Link>
        </>
      ),
    },
    {
      header: "Count Date",
      accessorKey: "Countdate",
      Cell: ({row}) => moment(row.original.Countdate).format("DD-MM-YYYY"),
    },
    {
      header: "Items Counted",
      accessorKey: "ItemsCounted",
    },
    {
      header: "Employee",
      accessorKey: "Employee",
    },
    {
      header: "Status",
      Cell: ({row}) => (
        <>
          <select className="form-control form-control-sm" value={row.original.Status == 3 ? 1 : 2}>
            <option value="" disabled>
              Select Status
            </option>
            <option value="1">Open</option>
            <option value="2">Close</option>
          </select>
        </>
      ),
    },
  ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header" style={
            {
              position: "fixed",
              top: "2px",
              zIndex: "999"
            }
          }>
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Count Inventory</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item"  style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item" >
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item active">Count Inventory</li>
              </ul>
            </div>
          </div>
          <div className="col-md-12">
            <div className="d-flex flex-row-reverse">
              <div className="p-2">
                <button
                  className={
                    status == "open" ? `btn btn-sm btn-success` : `btn btn-sm btn-primary`
                  }
                  // to="/show-closed-counts"
                  onClick={() => handleStatus(status)}
                >
                  {status == "open"
                    ? `Show Open Counts`
                    : `Show Closed Counts`}
                </button>
              </div>
              <div className="p-2">
                <button className="btn btn-sm btn-info" onClick={handleSubmit}>
                  New Inventory Count
                </button>
              </div>
            </div>
          </div>


          {/* Card for listing count inventory */}
          {/* <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="Count Inventory"
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangesPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  fixedHeader
                  // fixedHeaderScrollHeight="70vh"
                  persistTableHead
                  sortServer
                  
                  dense
                />
              </div>
            </div>
          </div> */}
           <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnResizing
            // enableRowActions
            // renderRowActionMenuItems={({ row }) =>
            //   [
            //     <MenuItem key="edit" onClick={() => navigate(`/manage-transfer/${row.original.ID}`)}>
            //       Edit
            //     </MenuItem>,
            //     <MenuItem
            //       className="confirm-text"
            //       to="#"
            //       // key="delete"
            //       title="Delete"
            //       data-bs-toggle="modal"
            //       data-bs-target="#DeleteConfirmationModal"
            //       onClick={() => handleDeletePopup(row.original.ID, "", "")}
            //     >
            //       Delete
            //     </MenuItem>,
            //     (row.original.Attachements) ? (
            //       <a
            //         className="dropdown-item confirm-text"
            //         href={row.original.Attachements}
            //         target="_blank"
            //         title="Attachment"
            //       >
            //         <MenuItem
            //           title="Attachment"
            //         >
            //           Attachments
            //         </MenuItem>
            //       </a>
            //     ) : ("")
            //   ]
            // }

            enableGrouping
            enableStickyHeader
            enableStickyFooter
            // enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "compact",
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            muiTablePaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: 'fit-content' } }}
            // manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                  color: 'error',
                  children: 'Error loading data',
                }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              // columnFilters,
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.itemsBaseUrl}/items/countitemsdeleted`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default CountInventory;
